import Markdown from 'react-markdown';

import { Prose } from '@nocowanie/common-ui/components/atoms/prose';

import { MarkdownRendererProps } from './markdown-rendererprops';

import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';

export const MarkdownRenderer = ({ content }: MarkdownRendererProps) => (
    <Prose>
        <Markdown rehypePlugins={[rehypeRaw, rehypeSanitize]}>{content}</Markdown>
    </Prose>
);
